var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "data-wrapper" },
    [
      _vm._l(_vm.dataTypes, function(dataType, index) {
        return [
          _vm.defer(index + 1)
            ? _c(
                "div",
                {
                  key: dataType,
                  class: [
                    "data-el",
                    _vm.toDisplayType(dataType, true),
                    {
                      "high-density": _vm.highDensity,
                      dim: _vm.dimAfter !== -1 && index >= _vm.dimAfter
                    }
                  ]
                },
                [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: _vm.$t("StateInspector.dataType.tooltip"),
                          expression: "$t('StateInspector.dataType.tooltip')"
                        }
                      ],
                      staticClass: "data-type selectable-item",
                      on: {
                        click: function($event) {
                          return _vm.toggle(dataType, $event)
                        }
                      }
                    },
                    [
                      _c("span", {
                        staticClass: "arrow right",
                        class: { rotated: _vm.isExpanded(dataType) }
                      }),
                      _c("span", { staticClass: "key" }, [
                        _vm._v(_vm._s(_vm.toDisplayType(dataType)))
                      ])
                    ]
                  ),
                  _c("StateFields", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.isExpanded(dataType),
                        expression: "isExpanded(dataType)"
                      }
                    ],
                    attrs: {
                      fields: _vm.state[dataType],
                      "force-collapse": _vm.forceCollapse
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }